// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import Input from 'antd/lib/input';

// EXPORTED COMPONENT
// ===================================
export class PasswordInput extends React.Component {
  render() {
    return <Input {...this.props} />;
  }
}

PasswordInput.propTypes = {
  size: PropTypes.string,
  error: PropTypes.bool,
};

// Specifies the default values for props:
PasswordInput.defaultProps = {
  size: 'large',
  error: null,
  type: 'password',
  placeholder: 'Password',
};

export default PasswordInput;



// WEBPACK FOOTER //
// ./src/components/inputs/PasswordInput/index.js